module.exports = __webpack_public_path__ + "img/3.1.24bf2594.png";